import { html } from 'lit-html'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

export default async function register (state, appOptions) {
  await import(/* webpackChunkName: 'pollev-register' */ '../../participant-components/register')

  return html`
    <layout-plain>
      <main slot='content'>
      <pec-participant-register
        @navigate=${(e) => {
          store.dispatch(appSlice.pageUpdated(e.detail.page))
        }}
      ></pec-participant-register>
      </main>
    </layout-plain>
  `
}
